export class CallPersistentRetryPolicy {
    nextRetryDelayInMilliseconds(retryContext) {
        const retryAttempt = retryContext.previousRetryCount;
        
        if (retryAttempt > 10) {
            // After 10 attempts, use fixed 30-second intervals
            return 5000; // 5 seconds
        }
        
        switch (retryAttempt) {
            case 0: return 0;     // Immediate first retry
            case 1: return 1000;  // 1 second
            case 2: return 2000;  // 2 seconds
            case 3: return 5000;  // 5 seconds
            case 4: return 7000; // 7 seconds
            case 5: return 10000; // 10 seconds
            case 6: return 13000; // 13 seconds
            case 7: return 16000; // 15 seconds
            case 8: return 18000; // 18 seconds
            default: return 20000; // 20 seconds
        }
    }
}